import { render, staticRenderFns } from "./MattReGI_List.vue?vue&type=template&id=d2459670"
import script from "./MattReGI_List.vue?vue&type=script&lang=js"
export * from "./MattReGI_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports